import {
  CreateHiringStageDocument,
  CreateHiringStageMutation,
  CreateHiringStageMutationVariables,
  GetHiringStagesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateHiringStage = () => {
  const [createAtsHiringStage, { loading }] = useMutation(CreateHiringStageDocument, {
    extractorFn: (data: CreateHiringStageMutation) => data.atsMutations.createAtsHiringStage,
  })

  return {
    loading,
    create(variables: CreateHiringStageMutationVariables) {
      return createAtsHiringStage({
        variables,
        refetchQueries: [GetHiringStagesDocument],
      })
    },
  }
}
